//#region Imports
import * as React from "react";
import { getDisplayName } from "@anydo/ui-react-utils";
import type { IAnalyticsContextValue } from "./IAnalyticsContextValue";
import { useAnalytics } from "./useAnalytics";
//#endregion

export function connectAnalytics<
  C extends React.ComponentType<P>,
  P extends IAnalyticsContextValue = React.ComponentProps<C>,
>(Component: React.ComponentType<P>) {
  // TODO: Find a solution to `any`
  type R = React.Ref<any>;
  type PT = React.PropsWithoutRef<IAnalyticsContextValue>;

  function ConnectedAnalytics(props: PT, ref?: R) {
    const context = useAnalytics();

    // @ts-expect-error Issue since TS 3.2.1
    return <Component ref={ref} {...props} {...context} />;
  }

  const ConnectedAnalyticsForwared_ = React.forwardRef(ConnectedAnalytics);
  if (__DEV__) ConnectedAnalyticsForwared_.displayName = `ConnectedAnalytics(${getDisplayName(Component)})`;

  return ConnectedAnalyticsForwared_;
}
